/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpinsights_Period_Arialabel3Inputs */

const en_coinvestments_lpinsights_period_arialabel3 = /** @type {(inputs: Coinvestments_Lpinsights_Period_Arialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select time period`)
};

/**
* | output |
* | --- |
* | "Select time period" |
*
* @param {Coinvestments_Lpinsights_Period_Arialabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpinsights_period_arialabel3 = /** @type {((inputs?: Coinvestments_Lpinsights_Period_Arialabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpinsights_Period_Arialabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpinsights_period_arialabel3(inputs)
});
export { coinvestments_lpinsights_period_arialabel3 as "coInvestments_lpInsights_period_ariaLabel" }